import React from 'react';
import PropTypes from 'prop-types';
import ColorPicker from 'components/pages/livefeed/Editor/EditorContainer/common/ColorPicker'
const FormatColor = (props) => {
    const { currentEntity } = props;
    const activeToolbarItems = currentEntity && currentEntity.activeToolbarItems;
    const shouldShow = currentEntity.id !== null && (
        activeToolbarItems[2].isText ||
        currentEntity.id === "line"
    );
    return (
        <React.Fragment>
            <ColorPicker
                className={`icon-wrapper justify-center icon-wrapper_color ${shouldShow ? '' : 'icon-wrapper_color_disable'}`}
                clickable={shouldShow}
            >
                <span style={{ display: "inline-flex" }} data-tooltip={"Text color"}>
                    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
                        <path className="shape" d='M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z' />
                        <path fill={currentEntity.color} className="Color-Line" d='M0 20h24v4H0z' />
                    </svg>
                </span>
            </ColorPicker>
        </React.Fragment>
    );
}

FormatColor.propTypes = {
    currentEntity: PropTypes.object.isRequired
}
export default FormatColor


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/ToolbarContainer/ToolbarOptions/FormatColor.jsx